import { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext(null);

export const LANGUAGES = [
  { code: "en", label: "English", nativeLabel: "English" },
  { code: "en-gb", label: "English (UK)", nativeLabel: "English (UK)" },
  { code: "hi", label: "Hindi", nativeLabel: "हिन्दी" },
  { code: "or", label: "Odia", nativeLabel: "ଓଡ଼ିଆ" },
  { code: "ml", label: "Malayalam", nativeLabel: "മലയാളം" },
  { code: "te", label: "Telugu", nativeLabel: "తెలుగు" },
  { code: "kn", label: "Kannada", nativeLabel: "ಕನ್ನಡ" },
  { code: "hne", label: "Chhattisgarhi", nativeLabel: "छत्तीसगढ़ी" },
  { code: "ta", label: "Tamil", nativeLabel: "தமிழ்" },
];

export const BIBLE_TRANSLATIONS = [
  { code: "KJV", label: "KJV", note: "Public domain — displayed in full." },
  { code: "NKJV", label: "NKJV", note: "Licensed — excerpt only." },
  { code: "ESV", label: "ESV", note: "Licensed — excerpt only." },
  { code: "NIV", label: "NIV", note: "Licensed — excerpt only." },
];

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("aj_lang") || "en");
  const [translation, setTranslation] = useState(() => localStorage.getItem("aj_translation") || "ESV");

  useEffect(() => {
    localStorage.setItem("aj_lang", lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  useEffect(() => {
    localStorage.setItem("aj_translation", translation);
  }, [translation]);

  return (
    <LangContext.Provider value={{ lang, setLang, translation, setTranslation }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used inside LangProvider");
  return ctx;
}
